<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
          <b-overlay :show="loading">
            <iq-card>
                <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                                    <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                        <b-row>
                                            <b-col lg="6" sm="12">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    :label="$t('grant_budget_management.fiscal_year')"
                                                    label-for="fiscal_year_id"
                                                >
                                                    <b-form-select
                                                        plain
                                                        v-model="dataArray.fiscal_year_id"
                                                        :options="fiscalYearList"
                                                        id="fiscal_year_id"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                </b-form-group>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                 <ValidationProvider name="Circular Memo" vid='circular_publication_id' rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="circular_publication_id"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('elearning_config.circular_memo_no') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.circular_publication_id"
                                                        @change="loadDateRange"
                                                        :options="circularPublicationList"
                                                        id="circular_publication_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Training Name" vid="training_title_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="training_title_id"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                            {{$t('elearning_config.training')}}  <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.training_title_id"
                                                        id="training_title_id"
                                                        :options="trainingNameList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Batch" vid="batch_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="batch_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('elearning_config.batch') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.batch_id"
                                                        id="batch_id"
                                                        :options="batchList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Batch Start Date" vid="batch_start_date" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="batch_start_date"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('application_management.start_date')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <flat-pickr class="form-control"
                                                            :disabled="isLoadDate ? false : true"
                                                            :config="{ minDate: startDate, maxDate: endDate }"
                                                            v-model="dataArray.batch_start_date"
                                                            :placeholder="$t('application_management.start_date')"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </flat-pickr>
                                                        <div class="invalid-feedback d-block">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Batch End Date" vid="batch_end_date" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="batch_end_date"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('application_management.end_date')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <flat-pickr class="form-control"
                                                            :disabled="isLoadDate ? false : true"
                                                            :config="{ minDate: startDate, maxDate: endDate }"
                                                            v-model="dataArray.batch_end_date"
                                                            :placeholder="$t('application_management.end_date')"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </flat-pickr>
                                                        <div class="invalid-feedback d-block">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                &nbsp;
                                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                            </div>
                                        </div>
                                    </b-form>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                </template>
            </iq-card>
          </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '../../../../../config/api_config'
import { batchScheduleStoreApi, batchScheduleUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import { circularDataApi } from '../../../training-plan-management/api/routes'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        this.dataArray.org_id = this.$store.state.dataFilters.orgId
        if (this.id) {
            const tmp = this.getCircularPublicationData()
            this.dataArray = tmp
            this.isLoadDate = true
        }
    },
    mounted () {
        core.index()
        flatpickr('.date-picker', {})
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            dataArray: {
                circular_memo_no: 0,
                training_title_id: 0,
                batch_id: 0,
                batch_start_date: '',
                batch_end_date: '',
                circular_publication_id: 0,
                fiscal_year_id: 0
            },
            loading: false,
            circularPublicationList: [],
            trainingNameList: [],
            isLoadDate: false,
            startDate: '',
            endDate: ''
        }
    },
    computed: {
        batchList: function () {
            return this.$store.state.TrainingElearning.commonObj.batchList.filter(item => item.status === 1)
        },
        currentLocale () {
            return this.$i18n.locale
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        }
    },
    watch: {
        'dataArray.fiscal_year_id': function (newVal) {
            this.circularPublicationList = this.getMomoList(newVal)
            this.trainingNameList = []
        },
        'dataArray.circular_publication_id': function (newVal, oldVal) {
            this.trainingNameList = this.trainingList(newVal)
            if (newVal !== oldVal) {
                this.getCircularData()
            }
        }
    },
    methods: {
        loadDateRange () {
            this.isLoadDate = true
        },
        trainingList (circularMemoId) {
            const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
            this.startDate = trainingObj.start_date
            this.endDate = trainingObj.end_date
            return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
                if (this.$i18n.locale === 'bn') {
                return { value: item.value, text: item.text_bn }
                } else {
                return { value: item.value, text: item.text_en }
                }
            })
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        async saveData () {
            this.loading = true
          this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }

            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${batchScheduleUpdateApi}/${this.id}`, this.dataArray)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, batchScheduleStoreApi, this.dataArray)
            }

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.warning'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.loading = false
                this.$bvModal.hide('modal-4')
            } else if (result.warning) {
            this.$toast.warn({
              title: this.currentLocale === 'bn' ? 'সতর্কতা' : 'Warning',
              message: result.message,
              color: '#D6E09B'
            })
            this.loading = false
          } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        getCircularPublicationData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getMomoList (fiscalYearId) {
            return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
      async getCircularData () {
        if (this.dataArray.fiscal_year_id && this.dataArray.circular_publication_id) {
          this.loading = true
          this.moduleSpinLoader = true
          const result = await RestApi.getData(trainingElearningServiceBaseUrl, circularDataApi, { fiscal_year_id: this.dataArray.fiscal_year_id, circular_id: this.dataArray.circular_publication_id })
          if (result.success) {
            this.dataArray.training_title_id = result.training
         /*   this.batchList = result.batch.map((item, index) => {
              return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch, text_bn: item.batch_d.batch_bn })
            }) */
            this.moduleSpinLoader = false
            this.loading = false
          }
        }
      }
    }
}

</script>
